// extracted by mini-css-extract-plugin
export default {"container":"SimplifiedFeedbackClosing_container__asPpQ","message":"SimplifiedFeedbackClosing_message__VM9aH","likeAnimation":"SimplifiedFeedbackClosing_likeAnimation__qmZ9k"};